import { cpf } from '@loggi/js/formatters';
import cnpj from '@loggi/js/formatters/cnpj';

export const CPF_LENGTH = 11;
export const CNPJ_LENGTH = 14;
export const MASKED_CPF_LENGTH = CPF_LENGTH + 3;
export const MASKED_CNPJ_LENGTH = CNPJ_LENGTH + 4;

// The onPasteFormatter function receives a cpf or cnpj number and returns a masked value.
// Differently than the onMaskedValueFormatter below, which receives a
// value every time the user types a new character on input text and returns it with a mask.

function onPasteFormatter(value) {
  const formatWithSpecialCharacters = /[./-]/;

  const hasSpecialCharacters = formatWithSpecialCharacters.test(value);

  if (
    value.length <= CPF_LENGTH ||
    (value.length <= MASKED_CPF_LENGTH && hasSpecialCharacters)
  ) {
    return cpf(value);
  }

  return cnpj(value);
}

function onMaskedValueFormatter(value) {
  if (value.length <= MASKED_CPF_LENGTH) {
    return cpf(value);
  }

  return cnpj(value);
}

function cpfOrCnpjFormatter() {
  return {
    onPasteFormatter,
    onMaskedValueFormatter
  };
}

export default cpfOrCnpjFormatter();
